import WasteSelectorTypes from "../WasteSelectorTypes";

export const ContainerMarkerSVG = (
    {
        type = 'gl',
        percent = 0
    }
) => {
    const {MarkerSVG, fillColor, borderColor, contrastColor, backgroundColor} = WasteSelectorTypes[type];
    return (
        <MarkerSVG
            fillColor={fillColor}
            borderColor={borderColor}
            contrastColor={contrastColor}
            backgroundColor={backgroundColor}
            percent={percent}
        />
    );
};
